<template>
    <Card
        v-if="meta && typeof meta.total === 'number'"
        :custom-classes="'tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-2 tw:pl-4 tw:pr-4 tw:md:pr-0 tw:py-2'"
    >
        <div class="tw:flex tw:flex-col tw:w-full tw:md:flex-row tw:md:items-center tw:md:justify-between">
            <div class="tw:flex tw:justify-between tw:items-center">
                <TableElementsPerPage v-model="model.per_page" />

                <div class="tw:text-gray-500 tw:text-sm tw:whitespace-nowrap tw:md:hidden">
                    Página {{ model.page || 1 }} de {{ totalPaginas || 1 }}
                </div>
            </div>

            <div class="tw:text-center tw:text-gray-400 tw:text-sm tw:hidden tw:md:block tw:flex-1">
                Mostrando {{ desde }} - {{ hasta }} de {{ meta.total || 0 }} resultados
            </div>

            <div class="tw:flex tw:justify-center tw:items-center tw:w-full tw:md:w-auto">
                <TablePagination
                    v-model="model.page"
                    :total="meta.total || 0"
                    :per-page="model.per_page || 5"
                />
            </div>
        </div>
    </Card>
</template>

<script setup>
    import TableElementsPerPage from '@/modules/admin/ui/table/TableElementsPerPage.vue'
    import TablePagination from '@/modules/admin/ui/table/TablePagination.vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import { computed } from 'vue'

    const props = defineProps({
        value: { type: Object, required: true },
        meta: { type: Object, default: () => ({}) }
    })

    const emit = defineEmits(['input'])

    const model = computed({
        get: () => props.value || {},
        set: val => emit('input', val)
    })

    const desde = computed(() => ((model.value.page || 1) - 1) * (model.value.per_page || 5) + 1)
    const hasta = computed(() => Math.min((model.value.page || 1) * (model.value.per_page || 5), props.meta.total || 0))
    const totalPaginas = computed(() => Math.ceil((props.meta.total || 0) / (model.value.per_page || 5)))
</script>
